import { MdAssistantNavigation } from "react-icons/md";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RotatableMarker = ({ rotation, color, vehNo, advDirSelected }) => {
  return (
    <div
      style={{
        display: "flex",
        transform: `rotate(${rotation - 45}deg)`,
      }}
    >
      <div style={{ position: "relative", translate: "0 0px" }}>
        {advDirSelected ? (
          <MdAssistantNavigation
            key={vehNo}
            style={{
              translate: "50% 50%",
              fontSize: "28px",
              color: color,
            }}
            icon={faLocationArrow}
          />
        ) : (
          <FontAwesomeIcon
            key={vehNo}
            style={{
              translate: "50% 50%",
              fontSize: "24px",
              color: color,
            }}
            icon={faLocationArrow}
          />
        )}

        <div
          style={{
            position: "absolute",
            top: "-10px",
            left: "10px",
            transform: `rotate(${45}deg)`,
            padding: "5px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            textAlign: "center",
            width: "80px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {vehNo}
        </div>
      </div>
    </div>
  );
};

export default RotatableMarker;
